<div class="pl-[19px] pr-[19px] !mb-[60px] flex">
  <div class="!w-[100%]">
    <div class="h-auto !bg-[#F8F8F8]">
      <div class="container flex !pt-[25px] !pb-[25px]">
        <h3 class="!text-[20px] !text-[#21252A] !font-bold !ml-[20px]">
          {{ projectName }} - Expression of Interests
        </h3>
      </div>
    </div>

    <table class="w-full bg-[#fcfcfd] table-auto !mt-[20px]">
      <thead
        class="h-[52px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !p-[20px]"
      >
        <tr>
          <th class="px-4 text-left w-[160px] header-field">EOI No.</th>
          <th class="px-4 py-2 text-center w-auto header-field">EOI Name</th>
          <th class="px-4 py-2 text-center w-auto header-field">Issue Date</th>
          <th class="px-4 py-2 text-center w-auto header-field">
            Submission Date
          </th>
          <th class="px-4 py-2 text-center w-auto header-field">
            Inquiry Deadline
          </th>
          <th class="px-4 py-2 text-center w-auto header-field">EPC Date</th>
        </tr>
      </thead>
      <tbody class="!text-center">
        <ng-container
          *ngFor="let projectEoiRequest of projectEoiRequests; let i = index"
        >
          <tr
            class="hover:bg-[#ffefe9] border-b-0"
            [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-[#DEE2E6]': i % 2 !== 0 }"
          >
            <td
              class="border-b-0 pr-4 pl-[1rem] py-2 w-auto cursor-pointer text-left whitespace-nowrap"
              (click)="openIndividualEOIView(projectEoiRequest?.id)"
            >
              {{ this.projectIdentifier }} - {{ projectEoiRequest?.code }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer"
              (click)="openIndividualEOIView(projectEoiRequest?.id)"
            >
              {{ projectEoiRequest?.name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ projectEoiRequest?.issue_date }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ projectEoiRequest?.submission_date }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ projectEoiRequest?.inquiry_deadline }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ projectEoiRequest?.epc_date }}
            </td>
            <!-- <td class="border-b-0 px-4 py-2 w-auto">
              TODO
            </td> -->
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
